import styled from "styled-components";
import {Button} from 'react-bootstrap';

export const PrimaryButton = styled(Button)`
  min-width: 200px;
  font-weight: 500;
  height: 50px;
  border-radius: 10px;
  font-size: 14px;
  display: block;
`

export const LinkButton = styled(Button)`
  color: black;
  font-weight: 500;
  font-size: 14px;

  &:hover, &:active {
    color: #363636 !important;
  }
`

export const IconButton = styled.button`
  border: none;
  background-color: inherit;
`

export const ButtonContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`

export const ButtonLoading = styled.div`
  .loader {
    width: 15px;
    aspect-ratio: 1;
    display: grid;
    -webkit-mask: conic-gradient(from 20deg, #0000, #000);
    animation: l26 1s infinite steps(12);
  }

  .loader,
  .loader:before,
  .loader:after {
    background: radial-gradient(closest-side at 50% 12.5%,
    #5d5d5d 96%, #0000) 50% 0/20% 80% repeat-y,
    radial-gradient(closest-side at 12.5% 50%,
    #5d5d5d 96%, #0000) 0 50%/80% 20% repeat-x;
  }

  .loader:before,
  .loader:after {
    content: "";
    grid-area: 1/1;
    transform: rotate(30deg);
  }

  .loader:after {
    transform: rotate(60deg);
  }

  @keyframes l26 {
    100% {
      transform: rotate(1turn)
    }
  }
`
